/**
 * Initialize consent management
 *
 * @param {HTMLElement} root
 */
const init = (root) => {
	root.classList.add('initialized');

	root.addEventListener('click', (event) => {
		if (window.UC_UI) {
			event.preventDefault();
			window.UC_UI.showSecondLayer();
		} else {
			console.error('UserCentrics UI is not available');
		}
	});
};

export const initConsentManagement = (root = document) => {
	const consentManagamentLinks = root.querySelectorAll('.js-consent-management:not(.initialized)');
	Array.from(consentManagamentLinks).forEach((root) => {
		init(root);
	});
};
